import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    mainSectionParent: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      paddingBottom: 100,
    },
    logo: {
      padding: "40px 60px",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      padding: "80px 120px 0px 120px",
      width: "100%",
    },
    headerWrapper: {
      display: "flex",
      gap: "8px",
    },
    header: {
      marginBottom: "32px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
    },
    heading: {
      ...theme.fonts.label2,
      color: theme.colors.textDefault,
    },
    passwordWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    password: {
      flex: 1,
    },
    currentPassword: {
      marginTop: "-16px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "end",
      gap: "8px",
      marginTop: "24px",
    },
    btn: {
      borderRadius: 0,
    },
    textfield: {
      paddingTop: 16,
      "& > *": {
        textAlign: "left",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
